import { render, staticRenderFns } from "./ChatChannelMessage.vue?vue&type=template&id=1713b368&scoped=true&lang=pug"
import script from "./ChatChannelMessage.vue?vue&type=script&lang=js"
export * from "./ChatChannelMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatChannelMessage.vue?vue&type=style&index=0&id=1713b368&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1713b368",
  null
  
)

export default component.exports